export default {
    brow: {
        xindex: 7,
        yindex: 6
    },
    eyes: {
        xindex: 11,
        yindex: 0
    },
    nose: {
        xindex: 0, 
        yindex: 1
    },
    noseprofile: {
        xindex: 2,
        yindex: 3
    },
    nosetip: {
        xindex: 5, 
        yindex: 4
    },
    cbones: {
        xindex: 9, 
        yindex: 8
    },
    cheeks: {
        xindex: 10,
        yindex: -1,
    },
    lips: {
        xindex: 12,
        yindex: -1
    },
    jaw: {
        xindex: 13, 
        yindex: 14
    },
    chinprofile: {
        xindex: 15, 
        yindex: 16
    },
    chinform: {
        xindex: 17, 
        yindex: 18
    },
}